
// Stripe's price and Product objects have more fields than this, which is why these are interfaces

export interface Price {
  id: string
  lookup_key: string
  nickname: string
  product: Product
  unit_amount: number
  metadata: Record<string, string>
  recurring?: Recurrence|null
}

export interface Product {
  id: string
  name: string
  description: string
  metadata: Record<string, string>
}

export type RecurrenceInterval = 'day' | 'week' | 'month' | 'year' | 'sporadic'

export interface Recurrence {
  interval: RecurrenceInterval
}

export function getProductSeats(product: Product): number|null {
  return parseInt(product.metadata['seats'], 10) || null // turns seats=0 and seats="bucket" into null, which is fine
}
